import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=2856f853&scoped=true&lang=pug&"
import script from "./BannerSwiper.vue?vue&type=script&lang=js&"
export * from "./BannerSwiper.vue?vue&type=script&lang=js&"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./BannerSwiper.vue?vue&type=style&index=1&id=2856f853&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856f853",
  null
  
)

export default component.exports